// extracted by mini-css-extract-plugin
module.exports = {"input-error":"styles_input-error__2sN8f","inputError":"styles_input-error__2sN8f","tip":"styles_tip__2OxNr","content":"styles_content__u0g8Y","icon":"styles_icon__3OwWr"};